import { observer } from 'mobx-react-lite';
import React from 'react';
import { Box, Button, Dialog, Flex, Text, TextField } from '@radix-ui/themes';
import { FormField } from 'shared/components';
import { VerifyAccountDialogStore } from './verify-account-dialog.store';
import './verify-account-dialog.scss';

type VerifyAccountDialogProps = {
   store: VerifyAccountDialogStore;
   title?: string;
   cancelText?: string;
   continueText?: string;
   openEmailText?: string;
   onActivated?: () => void;
};

function VerifyAccountDialogView({
   store,
   title = 'Verify your account',
   cancelText = 'Cancel',
   continueText = 'Continue',
   openEmailText = 'Open email app',
   onActivated,
}: VerifyAccountDialogProps) {
   const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      await store.confirmCode({
         onSuccess: async () => {
            store.closeDialog();
            await onActivated?.();
         },
      });
   };

   return (
      <Dialog.Root open={store.open} onOpenChange={store.setOpen}>
         <Dialog.Content
            maxWidth="560px"
            onOpenAutoFocus={(e) => e.preventDefault()}
            onInteractOutside={(e) => e.preventDefault()}
            className="verify-account-dialog"
         >
            <Flex justify="center" mb="3">
               <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
               >
                  <path
                     d="M32 8L56 52H8L32 8Z"
                     fill="#FFF7ED"
                     stroke="#F76B15"
                     strokeWidth="3"
                     strokeLinejoin="round"
                  />
                  <rect x="30" y="24" width="4" height="16" rx="2" fill="#F76B15" />
                  <rect x="30" y="44" width="4" height="4" rx="2" fill="#F76B15" />
               </svg>
            </Flex>

            <Dialog.Title>
               <Text size="6" weight="medium" align="center" as="div">
                  {title}
               </Text>
            </Dialog.Title>

            <Box mt="3">
               <Text size="3" color="gray" highContrast align="center" as="p">
                  {store.message}
               </Text>
            </Box>

            <Flex justify="center" mt="4" mb="3">
            </Flex>

            <form onSubmit={onSubmit}>
               <Box mt="2">
                  <FormField label="Код підтвредження" error={store.codeControl.error} required>
                     <TextField.Root
                        size="3"
                        value={store.codeControl.value}
                        placeholder="XXXXX"
                        onChange={(e) => store.codeControl.setValue(e.target.value)}
                     ></TextField.Root>
                  </FormField>
               </Box>

               <Flex justify="end" gap="4" mt="5">
                  <Dialog.Close>
                     <Button size="3" color="indigo" highContrast variant="outline" type="button">
                        {cancelText}
                     </Button>
                  </Dialog.Close>

                  <Button
                     size="3"
                     type="submit"
                     disabled={store.codeControl.invalid ? true : undefined}
                     loading={store.processing}
                  >
                     {continueText}
                  </Button>
               </Flex>
            </form>
         </Dialog.Content>
      </Dialog.Root>
   );
}

export const VerifyAccountDialog = observer(VerifyAccountDialogView);
